import Loader from '@/components/Loader.vue'

export default {
  install(Vue) {
    const api = {
      show: (data) => {
        const forceProps = {
          programmatic: true
        }

        let props = {}

        if (typeof data === 'string' || data instanceof String) {
          props.message = data
        } else {
          props = data
        }

        const propsData = { ...props, ...forceProps }

        return new (Vue.extend(Loader))({
          el: document.createElement('div'),
          propsData
        })
      }
    }

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$loader = api
  }
}
